import '../css/app.css'
import Alpine from "alpinejs";

// Alpine app
Alpine.data("app", () => ({
  showMobileNav: false,
}));

Alpine.start();

// Jump to element
const jumper = document.querySelectorAll("[data-ctrl='jumper']");

for (const link of jumper) {
  link.addEventListener("click", clickHandler);
}

function clickHandler(e) {
  e.preventDefault();
  const offset = 10;
  const href = this.getAttribute("href");
  const offsetTop = document.querySelector(href).offsetTop - offset;
  scroll({
    top: offsetTop,
    behavior: "smooth",
  });
}
